export const GET_MALWARE_SCAN_LOGS = "get_malware_scan_logs";
export const GET_MALWARE_SCAN_LOGS_SUCCESSFUL = "get_malware_scan_logs_successful";
export const GET_MALWARE_SCAN_LOGS_FAILED = "get_malware_scan_logs_failed";

export const CLEAR_ALL_MALWARE_SCAN_LOGS_MESSAGES = "clear_all_malware_scan_logs_messages";
export const CLEAR_ALL_MALWARE_SCAN_LOGS_SUCCESSFUL = "clear_all_malware_scan_logs_successful";